import StickyHeader from './StickyHeader'

export default StickyHeader
